import loadable from '@loadable/component'

export const EntryLink = loadable(() => import('./EntryLink'))
export const AssetLink = loadable(() => import('./AssetLink'))
export const ExternalLink = loadable(() => import('./ExternalLink'))
export const LocalizedLink = loadable(() => import('./LocalizedLink'))
export const UrlSlug = loadable(() => import('./UrlSlug'))
export const AutoLink = loadable(() => import('./AutoLink'))
